export async function checkAPIHealth(apiUrl: string): Promise<boolean> {
  try {
    console.log('🏥 Checking API health:', apiUrl);
    
    const response = await fetch(`${apiUrl}/health`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      console.error('❌ API health check failed:', response.status);
      return false;
    }
    
    const data = await response.json();
    console.log('✅ API health check passed:', data);
    return true;
    
  } catch (error) {
    console.error('❌ API health check error:', error);
    return false;
  }
}

export async function checkAuthHealth(apiUrl: string): Promise<boolean> {
  try {
    console.log('🔐 Checking Auth health:', apiUrl);
    
    const response = await fetch(`${apiUrl}/auth/health`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      console.error('❌ Auth health check failed:', response.status);
      return false;
    }
    
    const data = await response.json();
    console.log('✅ Auth health check passed:', data);
    return true;
    
  } catch (error) {
    console.error('❌ Auth health check error:', error);
    return false;
  }
}
